var map = {
	"./ar/education.json": 7866,
	"./de/education.json": 8600,
	"./en/education.json": 5531,
	"./es/education.json": 5225,
	"./fr/education.json": 7897,
	"./pt/education.json": 8240,
	"./ru/education.json": 8466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7447;